var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadIcon = function SvgDownloadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M16 16H0V0h16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5.171 12.179 8 15.006l2.829-2.828-.708-.708L8.5 13.093V5.01h-1v8.083L5.879 11.47zM13.5 4V2.5a.5.5 0 0 0-.41-.492L13 2H3a.5.5 0 0 0-.492.41L2.5 2.5V4h-1V2.5a1.5 1.5 0 0 1 1.356-1.493L3 1h10a1.5 1.5 0 0 1 1.493 1.356l.007.144V4z",
    clipRule: "evenodd"
  })));
};
export default SvgDownloadIcon;